export const NAV_LINKS = [
  { to: "/", label: "nav.home" },
  { to: "/about", label: "nav.about" },
  { to: "/buildings", label: "nav.buildings" },
  { to: "/cottages", label: "nav.cottages" },
  { to: "/renovations", label: "nav.renovations" },
  { to: "/faq", label: "nav.faq" },
];
